import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {DentnetCommunicatorService} from '../services/dentnet-communicator.service';
import {AppConstants} from '../../constants/app-constants';
import {UploadDataModelService} from '../data-models/upload-data-model.service';
import {RequestTimeService} from '../services/request-time.service';

@Injectable()
export class DownloadItemResolverService implements Resolve<any> {

  constructor(private communicator: DentnetCommunicatorService, private dataModel: UploadDataModelService, public requestTimeService: RequestTimeService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const uname = route.params['uname'];
    if (this.requestTimeService.calcDiff(this.dataModel.maxSecondsBetween, this.dataModel.lastRequest)
    ) {
      this.dataModel.lastRequest = Date.now();
      return this.communicator.view(AppConstants.UPLOADS, this.dataModel, uname);
    }
    return true;
  }

}
